/* globals window */
import { HashRouter, Route } from 'react-router-dom';

import CartAppLoader from 'cart/CartAppLoader';
import CheckoutAppLoader from 'checkout/CheckoutAppLoader';
import ClubSignupRedirect from 'club/ClubSignupRedirect';
import ClubList from 'club/List';
import ClubSignupAppLoader from 'clubSignup/ClubSignupAppLoader';
import {
  getProfileBase,
  getProductBase,
  getReservationBase,
  getCheckoutBase,
  getCollectionBase,
  getCartBase,
  getClubBase
} from 'common/helpers/routerHelper';
import CollectionLoader from 'products/CollectionLoader';
import ProductLoader from 'products/ProductLoader';
import ProfileAppLoader from 'profile/ProfileAppLoader';
import ReservationAppLoader from 'reservation/ReservationAppLoader';
import ReservationTypeAppLoader from 'reservation/ReservationTypeAppLoader';
import ReservationCartAppLoader from 'reservationCart/ReservationCartAppLoader';

import ScrollToTop from './common/components/routes/ScrollToTop';
import URLHistory from './common/components/routes/UrlHistory';

const HashRoutes = () => {
  const { pathname } = window.location;

  const rootPathname = `/${pathname.split('/')[1]}`;

  let routes;

  switch (rootPathname) {
    case getProfileBase():
      routes = <Route component={ProfileAppLoader} />;
      break;
    case getCollectionBase():
      routes = <Route path="/:slug" component={CollectionLoader} />;
      break;
    case getProductBase():
      routes = <Route path="/:slug" component={ProductLoader} />;
      break;
    case getClubBase():
      routes = (
        <>
          <Route exact path="/" component={ClubList} />
          <Route exact={false} path="/:slug" component={ClubSignupRedirect} />
        </>
      );
      break;
    case getCartBase():
      routes = <Route exact={false} path="/" component={CartAppLoader} />;
      break;
    case getReservationBase():
      routes = (
        <>
          <Route exact path="/" component={ReservationAppLoader} />
          <Route
            exact={false}
            path="/type/:slug"
            component={ReservationTypeAppLoader}
          />
        </>
      );
      break;
    case getCheckoutBase():
      routes = (
        <>
          <Route exact={false} path="/cart" component={CheckoutAppLoader} />
          <Route exact={false} path="/club" component={ClubSignupAppLoader} />
          <Route
            exact={false}
            path="/reservation"
            component={ReservationCartAppLoader}
          />
        </>
      );
      break;
    default:
      break;
  }

  return (
    <HashRouter>
      {routes}
      <ScrollToTop />
      <URLHistory />
    </HashRouter>
  );
};

export default HashRoutes;
